import type { GetMySubscriptionTierResult } from "api-contracts/rpc/get-my-subscription-tier";
import { queryOptions } from "../query-options";
import { rpc } from "../services/rpc";

/**
 * Query options for getting creator's subscription tier
 * Returns null if creator has no tier, or tier details if exists
 */
export const getMySubscriptionTierQueryOptions = () =>
  queryOptions<GetMySubscriptionTierResult>({
    queryKey: ["subscription-tier", "my"],
    queryFn: () => rpc("get-my-subscription-tier", {}) as Promise<GetMySubscriptionTierResult>,
  });
